module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('textarea-autosize', {
    ref: "commentBox",
    staticClass: "quick-input white-background add-comment",
    attrs: {
      "placeholder": _vm.placeHolder,
      "min-height": 30,
      "max-height": 350,
      "type": "text"
    },
    nativeOn: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 68) { return null; }
        if (!$event.ctrlKey) { return null; }
        $event.preventDefault();
        return _vm.demoData($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 68) { return null; }
        if (!$event.metaKey) { return null; }
        $event.preventDefault();
        return _vm.demoData($event)
      }],
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        $event.preventDefault();
        return _vm.saveComment($event)
      }
    },
    model: {
      value: (_vm.currentComment.text),
      callback: function($$v) {
        _vm.$set(_vm.currentComment, "text", $$v)
      },
      expression: "currentComment.text"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "1px",
      "margin-left": "-6px"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.showAllComments
    }
  }, [_c('v-list-item-title', [_vm._v("Show All")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.snippets), function(snippet) {
    return _c('v-list-item', {
      key: snippet.title,
      on: {
        "click": function($event) {
          return _vm.useSnippet(snippet)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(snippet.title))])], 1)
  })], 2)], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.comments), function(comment) {
    return _c('div', {
      key: comment.key,
      staticClass: "comment selectable hoverable",
      class: {
        selected: comment.selected, important: comment.important
      },
      on: {
        "click": [function($event) {
          if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
          return _vm.selectSingle(comment)
        }, function($event) {
          if (!$event.shiftKey) { return null; }
          return _vm.selectRange(comment)
        }, function($event) {
          if (!$event.metaKey) { return null; }
          return _vm.selectMulti(comment)
        }, function($event) {
          if (!$event.ctrlKey) { return null; }
          return _vm.selectMulti(comment)
        }]
      }
    }, [_c('div', {
      staticClass: "indicator"
    }, [_c('div', {
      staticStyle: {
        "float": "right",
        "margin-top": "-1px",
        "margin-right": "-7px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
        }
      }
    }, [_c('v-menu', {
      attrs: {
        "left": "",
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            staticClass: "menu-icon"
          }, on), [_vm._v("more_vert")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.makeTask(comment)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Task Me Tomorrow")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.scheduleTask(comment)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Schedule Task")])], 1), _vm._v(" "), (!comment.important) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.makeImportant(comment)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Important")])], 1) : _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.removeImportant(comment)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Not Important")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.editComment(comment)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Edit")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.deleteComment(comment)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete")])], 1)], 1)], 1)], 1), _vm._v(" "), (comment.complete) ? _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("check_circle_outline")]) : _vm._e(), _vm._v(" "), _c('span', {
      class: {
        'comment-complete': comment.complete, 'comment-milestone': comment.milestone
      },
      domProps: {
        "innerHTML": _vm._s(_vm.lineBreaks(comment.text))
      }
    }), _vm._v(" "), (comment.complete) ? _c('span', [_vm._v("- Completed")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "grey--text text--lighten small-text"
    }, [_vm._v(_vm._s(_vm.stamp(comment)))])], 1)])
  }), _vm._v(" "), (!_vm.allCommentsMode) ? _c('div', {
    staticClass: "grey--text",
    staticStyle: {
      "padding-left": "12px"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.comments.length || 'No') + " '" + _vm._s(_vm.commentType) + "' comments \n        "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showAllComments($event)
      }
    }
  }, [_vm._v("Show all")])]) : _vm._e(), _vm._v(" "), _c('TaskDialog', {
    attrs: {
      "task": _vm.taskDialog.model,
      "settings": _vm.taskDialog.settings
    },
    on: {
      "save": _vm.saveTask
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-210dc8a3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/TransactionComments.vue
// module id = 2478
// module chunks = 1